export const i18n = ({ index, language }) => {
  const translations = {
    reserve: {
      en: "RESERVE",
      es: "RESERVAS",
      pr: "RESERVAS",
    },
    contact: {
      en: "CONTACT",
      es: "CONTACTO",
      pr: "CONTATO",
    },
    home: {
      en: "HOME",
      es: "INICIO",
      pr: "HOME",
    },
    events: {
      en: "EVENTS",
      es: "EVENTOS",
      pr: "EVENTOS",
    },
    trabaja: {
      en: "WORK WITH US",
      es: "TRABAJA CON NOSOTROS",
      pr: "TRABALHE CONOSCO",
    },
    events_large: {
      en: "150 guests or more:",
      es: "150 personas o más:",
      pr: "150 pessoas ou mais:",
    },
    events_small: {
      en: "Fewer than 150 guests:",
      es: "Menos de 150 invitados:",
      pr: "Menos de 150 convidados:",
    },
    home1: {
      en: "I'MARANGATÚ, A PLACE FOR YOU",
      es: "I'MARANGATÚ, TU LUGAR",
      pr: "I'MARANGATÚ, SEU LUGAR",
    },
    home2: {
      en: "Reserve",
      es: "Reservar",
      pr: "Reserva",
    },
    home3: {
      en: "Reserve now.",
      es: "Reservar ahora.",
      pr: "Reserve agora.",
    },
    home4: {
      en: "Breakfast to dinner.",
      es: "Desayuno a cena.",
      pr: "Do café da manhã ao jantar.",
    },
    sus1: {
      en: "SUSTAINABILITY AT OUR PLACE",
      es: "PARADOR SUSTENTABLE",
      pr: "PARADEIRO SUSTENTÁVEL",
    },
    sus2: {
      en: "I'marangatú restaurant is committed to sustainability. We embrace environmental responsibility as an essential part of our identity.",
      es: "I'marangatú es un restaurante comprometido con la sostenibilidad. Abrazamos la responsabilidad ambiental como parte esencial de nuestra identidad.",
      pr: "I'marangatú é um restaurante comprometido com a sustentabilidade. Assumimos a responsabilidade ambiental como parte essencial da nossa identidade.",
    },
    sus3: {
      en: "United with the sun, the light that runs through our facilities comes from panels that provide us with solar energy. In addition, we take advantage of this generation to power our electric car chargers.",
      es: "Unidos al sol, la luz que corre por nuestras instalaciones proviene de lo que nos brinda la energía solar. Fomentamos la movilidad de bajas emisiones con cargadores de autos y eligiendo como vehículo de la empresa la movilidad eléctrica.",
      pr: "Unidos ao sol, a luz que flui pelas nossas instalações provém de painéis que nos fornecem energia solar. Além disso, aproveitamos esta geração para alimentar nossos carregadores dos carros elétricos.",
    },
    sus4: {
      en: "On the other hand, we have implemented a water purification plant that allows us to significantly reduce our use of drinking water, We also joined forces with Eco Beach, an innovative company born in Ibiza that focuses on beach cleaning.",
      es: "Contamos con una planta potabilizadora de agua que permite reducir significativamente nuestro uso de agua potable y nos unimos a Eco Beach, una innovadora empresa que nace en Ibiza y se enfoca en la limpieza de playas.",
      pr: "Por outro lado, implementámos uma estação de purificação de água que nos permite reduzir significativamente o consumo de água potável e juntámo-nos à Eco Beach, uma empresa inovadora que nasceu em Ibiza e se dedica à limpeza de praias.",
    },
    sus5: {
      en: "In addition, we have sustainable heating: we incorporated pellet stoves and use recycled wood as fuel.",
      es: "Nuestra forma de calefacción es sustentable: con estufas a pellets utilizamos madera reciclada como combustible.",
      pr: "Além disso, temos aquecimento sustentável: incorporamos fogões a pellets e utilizamos madeira reciclada como combustível.",
    },
    sus6: {
      en: "We continue to advance on our path towards an increasingly sustainable and environmentally friendly operation.",
      es: "Seguimos avanzando en nuestro camino hacia una operación cada vez más sostenible y amigable con el entorno.",
      pr: "Continuamos avançando em nosso caminho rumo a uma operação cada vez mais sustentável e ecologicamente correta.",
    },
    sus7: {
      en: "As part of our commitment to resource conservation and improving our energy performance, we are working on implementing the ISO 50001:2018 standard. Our objectives are to reduce water consumption, reduce electricity consumption, and obtain the certification.",
      es: "Como parte de nuestro compromiso con el cuidado de los recursos y la mejora de nuestro desempeño energético, estamos trabajando en la implementación de la norma ISO 50001:2018. Nuestros objetivos son: reducir el consumo de agua, reducir el consumo de energía eléctrica, obtener la certificación mencionada.",
      pr: "Como parte de nosso compromisso com a preservação de recursos e a melhoria do nosso desempenho energético, estamos trabalhando na implementação da norma ISO 50001:2018. Nossos objetivos são: reduzir o consumo de água, reduzir o consumo de energia elétrica e obter a certificação mencionada.",
    },
    sus8: {
      en: "To achieve this, we need everyone's commitment. Below is a brief video so you can learn about our Energy Policy and understand why it is important for all of us to be part of this commitment.",
      es: "Para logarlo, necesitamos el compromiso de todos. Les compartimos un breve video para conocer nuestra Política Energética y entender por qué es importante que todos seamos parte de este compromiso.",
      pr: "Para alcançar esse objetivo, precisamos do compromisso de todos. Compartilhamos um breve vídeo para que conheçam nossa Política Energética e entendam por que é importante que todos façamos parte desse compromisso.",
    },
    dance: {
      en: "We love to see you dance!",
      es: "Nos encanta verte bailar!",
      pr: "Adoramos ver você dançar!",
    },
    listen: {
      en: "Listen to our playlists on:",
      es: "Escucha nuestras playlists en:",
      pr: "Ouça nossas playlists em:",
    },
    menu_intro: {
      en: "« Our menu is a journey of colors, sensations, and moments. It’s on an abstract plane where the combinations of dishes reveal their colors, textures, and flavors. Cooking is, above all, visual, photographic, and artistic. »",
      es: "« Nuestra carta es un viaje de colores, sensaciones y momentos. Es en un plano abstracto donde se ven las combinaciones de platos con sus colores, sus texturas y sus sabores. La cocina es en un principio visual, fotográfica y artística. »",
      pr: "« Nosso cardápio é uma viagem de cores, sensações e momentos. É em um plano abstrato que se revelam as combinações dos pratos com suas cores, texturas e sabores. A cozinha é, antes de tudo, visual, fotográfica e artística. »",
    },
    mati: {
      en: " - Matías Sanjurjo, Head Chef",
      es: " - Matías Sanjurjo, Chef Ejecutivo",
      pr: " - Matías Sanjurjo, chefe de cozinha",
    },
    poem1: {
      en: "How does it feel to be in your place?",
      es: "¿Cómo es estar en tu lugar?",
      pr: "Como é estar no seu lugar?",
    },
    poem2: {
      en: "Between plants, umbrellas, and wood",
      es: "Entre plantas, sombrillas y madera,",
      pr: "Entre plantas, guarda-sóis e madeira,",
    },
    poem3: {
      en: "As waves sing softly in grace",
      es: "Oyendo de fondo las olas del mar",
      pr: "Ouvindo ao fundo o som do mar",
    },
    poem4: {
      en: "The sacred waters, calm and bright,",
      es: "El agua mansa y sagrada",
      pr: "A água mansa e sagrada",
    },
    poem5: {
      en: "Join you from the first light",
      es: "Te acompaña al llegar,",
      pr: "Te recebe ao chegar,",
    },
    poem6: {
      en: "While the orange sun in the afternoon",
      es: "Y el sol naranja en la tarde,",
      pr: "E o sol laranja à tarde,",
    },
    poem7: {
      en: "With some wine in hand",
      es: "Mientras tomás algo fresco",
      pr: "Enquanto bebes algo fresco",
    },
    poem8: {
      en: "And your feet in the sand,",
      es: "Con los pies en la arena,",
      pr: "Com os pés na areia,",
    },
    poem9: {
      en: "Waits for dinner and the moon to rise.",
      es: "Espera tranquilo la luna y la cena.",
      pr: "Espera tranquilo a lua e o jantar.",
    },
    poem10: {
      en: "Here, the only rush is to arrive,",
      es: "Donde la única prisa está en llegar,",
      pr: "Onde a única pressa é a de chegar,",
    },
    poem11: {
      en: "And so we say, without a doubt",
      es: "Nos atrevemos a decirlo:",
      pr: "Ousamos dizer:",
    },
    poem12: {
      en: "I’marangatú is your hideout.",
      es: "I'marangatú es tu lugar.",
      pr: "I'marangatú é o seu lugar.",
    },
  };

  const translation = translations[index][language];

  return translation;
};

export const Language = () => {};
